"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.destroyUserRecipe = exports.updateUserRecipe = exports.createUserRecipe = void 0;
function createUserRecipe(client, opts) {
    return client.post('create_user_recipe', opts.recipe);
}
exports.createUserRecipe = createUserRecipe;
function updateUserRecipe(client, opts) {
    return client.post('update_user_recipe', opts.recipe);
}
exports.updateUserRecipe = updateUserRecipe;
function destroyUserRecipe(client, opts) {
    return client.post('destroy_user_recipe', {
        uid: opts.uid
    });
}
exports.destroyUserRecipe = destroyUserRecipe;
